import widgetLoader from 'dibs-widget-loader';
import { getBuyerId } from 'dibs-cookie-jar';

export function loadSocialNetworks() {
    const hasUserId = !!getBuyerId(document.cookie);

    if (!hasUserId) {
        widgetLoader.load('google');
        widgetLoader.load('facebook');
    }
}
